import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';


// @dynamic
export class TaxHubDynamicComponentHelper {
  static components: any;

  static create (): void {
  }

  public static init () {
    if (TaxHubDynamicComponentHelper.components) {
      return;
    }
    const components = {};

    TaxHubDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }
  public static register(key: string, component: any) {
    TaxHubDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
  public static getComponentArray (): any[] {
    TaxHubDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(TaxHubDynamicComponentHelper.components).forEach(key => {
      componentArray.push(TaxHubDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
